import { G } from '@mobily/ts-belt'
import type { RouteRecordSingleViewWithChildren } from 'vue-router'

import { EmptyPage } from '@/pages/EmptyPage'
import { authService } from '@/services/authService'

export const authRouter: RouteRecordSingleViewWithChildren = {
  children: [
    {
      beforeEnter: () => {
        authService.deleteTokens()
        authService.redirectToLogoutPage()
      }, // This path is used to logout frontend from backend
      component: EmptyPage,
      name: 'LogoutBase',
      path: 'logout',
    },
    {
      name: 'HijackLogin', // This path is used to hijack functionality
      path: 'hijack/login',
      redirect: () => {
        authService.deleteTokens()
        return { path: '/dashboard' }
      },
    },
    {
      beforeEnter: () => {
        authService.deleteTokens()
        window.location.replace(`${import.meta.env.VUE_APP_HOST}/admin`)
      }, // This path is used to hijack functionality
      component: EmptyPage,
      name: 'HijackLogout',
      path: 'hijack/logout',
    },
    {
      name: 'AuthBase',
      path: ':accessToken/:refreshToken',
      redirect: to => {
        if (G.isString(to.params.accessToken) && G.isString(to.params.refreshToken)) {
          authService.updateTokens(to.params.accessToken, to.params.refreshToken)
        } else {
          authService.deleteTokens()
        }
        const path = to.query.path ?? ''
        return { path: path.toString(), query: {} }
      },
    },
  ],
  path: '/session',
  redirect: { name: 'auth' },
}
